

















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  parseZhinengwuzangResult,
  getEvilBarOption,
  getOrganRadarOption,
  getYangYinBarOption,
  ZhinengwuzangParsed,
} from "@/utils/parseZhinengwuzang";

@Component({})
export default class Name extends Vue {
  @Prop()
  private ifEdit: any;
  @Prop()
  private patient: any;
  @Prop()
  private data: any;
  @Prop()
  private config: any;

  private parsed: ZhinengwuzangParsed | null = null;
  private evilBarOption: any = {};
  private organRadarOption: any = {};
  private yangYinBarOption: any = {};

  private get mainSymptoms(): string {
    const parts: string[] = [];
    const main = (this.data["主要症状"] || "").trim();
    const tongue = (this.data["舌脉症状"] || "").trim();
    if (main) {
      parts.push(main);
    }
    if (tongue) {
      parts.push(tongue);
    }
    return parts.length > 0 ? parts.join("；") : "/";
  }

  private get hasHealthPlan(): boolean {
    const plans = this.data["养生方案"] || [];
    const suggestions = this.data["方案建议"] || [];
    return plans.length > 0 || suggestions.length > 0;
  }

  @Watch("data", { immediate: true, deep: true })
  private dataChange() {
    this.parseData();
  }

  private parseData() {
    const raw =
      this.data["评估结果"] || this.data["中医辨证结果"] || "";
    this.parsed = parseZhinengwuzangResult(raw);
    if (!this.parsed) {
      return;
    }
    if (this.parsed.chartCount >= 3) {
      this.evilBarOption = getEvilBarOption(this.parsed.evilScores);
      this.yangYinBarOption = getYangYinBarOption(
        this.parsed.yangScore,
        this.parsed.yinScore
      );
    }
    if (this.parsed.chartCount >= 1) {
      this.organRadarOption = getOrganRadarOption(this.parsed.organScores);
    }
  }

  private openHealthPlan() {
    const plans = this.data["养生方案"] || [];
    if (plans.length > 0 && plans[0].url) {
      window.open(plans[0].url);
      return;
    }
    const suggestions = this.data["方案建议"] || [];
    if (suggestions.length > 0) {
      const item = suggestions[0];
      if (item.type === "file" && item.path) {
        window.open(item.path);
      }
    }
  }
}
